import FilterNewTag from "app/pages/sales-intelligence/common-components/filters-panel/components/FilterNewTag/FilterNewTag";
import { filterUsageMap } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterDefinition";

import LeadScoreFilter from "../../components/filters/LeadScoreFilter/LeadScoreFilter";
import LeadScoreFilterResult from "../../components/filters/LeadScoreFilter/LeadScoreFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import leadsSearchFiltersI18nKeys from "../../utils/i18n";
import { defineDescriptionFilter } from "../defineSourcedFilter";

import LeadScoreFilterModel from "./LeadScoreFilterModel";

export const leadScoresDefinition = defineDescriptionFilter({
    key: "leadScores",
    apiCategory: leadsFilterApiCategory.leadScores,
    category: leadsFilterCategoryMap.company,
    usages: [filterUsageMap.search],
    trackingName: "Lead Score",
    titleKey: { key: leadsSearchFiltersI18nKeys.filter("leadScores") },

    render: ({ description, hasScoringRules, enabledLeadScoreTiers }) => ({
        tooltipText: { key: leadsSearchFiltersI18nKeys.filterGroupTooltip("leadScores") },
        filter: new LeadScoreFilterModel(hasScoringRules, description.leadScoreGroups ?? [], enabledLeadScoreTiers),
        filterView: LeadScoreFilter,
        filterResultView: LeadScoreFilterResult,
        tag: FilterNewTag,
    }),
});
